// Textos de los errores del API (WS-2311). Ver api-errors/es.ts.
export const locale = {
  lang: 'ca',
  data: {
    API_ERRORS: {
      AND_MORE: '{{message}} (i {{count}} més)',

      TYPE: {
        resource_not_found: 'No hem trobat el recurs sol·licitat.',
        action_unauthorized: 'No tens permisos per fer aquesta acció.',
        internal_error: 'S\'ha produït un error inesperat. Torna-ho a provar d\'aquí a uns minuts.',
        save_failed: 'No s\'ha pogut desar. Torna-ho a provar d\'aquí a uns minuts.',
        load_failed: 'No s\'han pogut carregar les dades. Torna-ho a provar d\'aquí a uns minuts.',
        headquarters_already_exists: 'L\'empresa ja té seu central.',
        delete_failed: 'No s\'ha pogut eliminar. Torna-ho a provar d\'aquí a uns minuts.',
        upstream_unavailable: 'El servei no està disponible en aquest moment. Torna-ho a provar més tard.',

        // Flotas de taxi/VTC (docs/flotas-drivers/api-contract.md)
        fleet_onboarding_incomplete: 'Falten passos de l\'alta per completar.',
        legal_texts_outdated: 'Els textos legals han canviat. Revisa\'ls i accepta\'ls de nou.',
        membership_not_pending: 'Aquesta sol·licitud ja no està pendent. Torna a carregar la llista.',
        vehicle_plate_taken: 'Aquesta matrícula ja està donada d\'alta en una flota.',
        shifts_locked: 'Per assignar torns cal almenys un vehicle i un conductor acceptat.',
        shifts_outdated: 'Algú ha canviat els torns mentre els editaves. Torna\'ls a carregar.',
        shift_conflict: 'Hi ha conflictes en els torns. Revisa les cel·les marcades.',
        member_already_exists: 'Aquesta persona ja és a l\'equip.',
        last_owner: 'La flota ha de tenir almenys un propietari.',
        document_already_reviewed: 'Una altra persona ja ha revisat aquest document. Torna a carregar la cua.',
        billing_not_in_review: 'Les dades de facturació ja no estan pendents de revisió. Torna a carregar la fitxa.',

        account_banned: 'El compte està bloquejat. Contacta amb suport per reactivar-lo.',
        already_decided: 'Aquesta retirada ja es va aprovar o rebutjar. Recarrega la fitxa.',
        already_has_matches: 'La rutina ja té matches i no es pot modificar.',
        birth_date_required: 'Falta la data de naixement de l\'usuari, necessària per obrir el seu compte de cobrament.',
        campaign_not_cancellable: 'La campanya ja està tancada i no es pot cancel·lar.',
        card_already_canceled: 'La targeta està cancel·lada i ja no es pot modificar.',
        card_generation_disabled: 'L\'emissió de targetes està desactivada en aquest moment.',
        card_not_eligible_not_in_driver_program: 'L\'usuari no és al programa de conductors, així que no li correspon targeta.',
        card_not_eligible_pilot_restricted: 'La targeta és en una prova pilot i aquest usuari no en forma part.',
        card_not_found: 'L\'usuari no té cap targeta de conductor.',
        card_not_issued_yet: 'La targeta encara no s\'ha emès.',
        conflict: 'S\'ha desat una altra operació alhora. Recarrega i torna-ho a provar.',
        coupon_already_applied: 'L\'usuari ja ha aplicat aquest cupó.',
        coupon_expired: 'El cupó ha caducat.',
        coupon_not_active_yet: 'El cupó encara no està actiu.',
        coupon_not_eligible: 'El cupó no és aplicable a aquest usuari.',
        coupon_not_found: 'No hem trobat el cupó.',
        date_overlap: 'Les dates i els horaris de la rutina coincideixen amb una altra rutina de l\'usuari.',
        document_already_in_use: 'Aquest document d\'identitat ja està associat a un altre compte.',
        document_data_unreadable: 'No s\'han pogut llegir les dades del document escanejat.',
        document_mismatch: 'Les dades del carnet de conduir no coincideixen amb les del document d\'identitat.',
        document_not_scanned: 'No s\'ha llegit el carnet de conduir. Cal tornar-lo a escanejar.',
        document_verification_required: 'Cal verificar el document d\'identitat abans d\'afegir un compte bancari.',
        empty_segment: 'El segment no té destinataris disponibles.',
        face_verification_already_completed: 'Aquesta verificació facial ja ha acabat.',
        face_verification_already_passed: 'L\'usuari ja ha superat la verificació facial per a aquest viatge.',
        face_verification_not_required: 'Aquest usuari no necessita verificació facial.',
        face_verification_provider_unavailable: 'El servei de verificació facial no respon. Torna-ho a provar més tard.',
        face_verification_required: 'Cal superar la verificació facial abans d\'acabar el viatge.',
        feature_locked: 'Aquesta secció no està inclosa al pla contractat per l\'empresa.',
        field_not_editable: 'Aquest camp no es pot editar.',
        group_not_cancellable: 'El grup no té cap campanya activa per cancel·lar.',
        iban_already_registered: 'Aquest IBAN ja està registrat al compte.',
        identity_data_missing: 'Falten dades de la identitat verificada per comparar el document.',
        identity_document_mismatch: 'El document escanejat no és el mateix que el del compte.',
        identity_mismatch: 'Les dades del document no coincideixen amb les del compte.',
        import_already_running: 'Ja hi ha una importació de POI en curs. Espera que acabi abans de llançar-ne una altra.',
        insufficient_balance: 'No hi ha prou saldo per a aquesta operació.',
        invalid_category: 'El carnet de conduir no té la categoria B.',
        invalid_status: 'La verificació del carnet de conduir no s\'ha completat.',
        label_not_applicable_to_pooling_route: 'Aquesta etiqueta no es pot assignar a viatges.',
        label_not_applicable_to_user: 'Aquesta etiqueta no es pot assignar a usuaris.',
        last_default_bank_account: 'És l\'únic compte bancari: afegeix-ne un altre abans d\'eliminar-lo.',
        license_data_unreadable: 'No s\'han pogut llegir totes les dades del carnet de conduir.',
        matricula_max_users: 'Aquesta matrícula ja té el màxim d\'usuaris associats.',
        negative_balance_blocked: 'El compte té saldo negatiu i està bloquejat fins que el regularitzi.',
        no_payment_method: 'L\'empresa no té cap targeta registrada.',
        not_pausable: 'Només es poden pausar les rutines recurrents.',
        overlap: 'La rutina coincideix amb una altra rutina de l\'usuari.',
        payment_in_progress: 'La retirada s\'està pagant ara mateix. Recarrega d\'aquí a uns minuts.',
        payout_failed: 'No s\'han pogut retirar els diners. Torna-ho a provar.',
        payout_recording_failed: 'El pagament s\'ha processat però no s\'ha pogut registrar. No el repeteixis: contacta amb suport.',
        pmst_disabled: 'L\'empresa ha desactivat el PMST.',
        polyline_unavailable: 'No s\'ha pogut calcular la ruta del viatge. Torna-ho a provar.',
        recipient_not_cancellable: 'L\'incentiu d\'aquest destinatari ja no està pendent.',
        reference_selfie_missing: 'No hi ha selfie de referència: cal verificar la identitat abans.',
        route_not_active: 'El viatge no està pendent ni en curs.',
        route_not_driver: 'Aquest viatge és de passatger i no té desglossament de preu.',
        routine_limit_reached: 'L\'usuari ha arribat al màxim de rutines actives.',
        routine_not_flexible: 'Aquesta opció només està disponible per a rutines flexibles.',
        seat_limit_reached: 'S\'han esgotat les places del pla de l\'empresa.',
        stripe_account_not_created: 'Encara no hi ha compte de cobrament: es crea en afegir el primer compte bancari.',
        stripe_connect_id_missing: 'L\'empresa no té cap compte de cobrament configurat.',
        trial_locked: "La prova de la teva empresa ha acabat. Completa el teu compte a Pla per continuar fent servir el dashboard.",
        user_profile_not_verified: 'Cal verificar la identitat abans de retirar saldo.',
        vehicle_overlap: 'El vehicle ja és en una altra rutina amb les mateixes dates i horaris.',
        user_whitelisted: 'L\'usuari és a la llista blanca de frau: treu-lo\'n abans de posar-lo en verificació reforçada.',
        week_has_matches: 'Aquesta setmana ja té matches i no es pot replanificar.',
        without_cost_distance_exceeded: 'El viatge sense cost supera la distància màxima permesa.',
        without_cost_not_allowed: 'Aquest usuari no pot crear viatges sense cost.',
        // Catálogo de eventos del backoffice (trips-core)
        event_category_base: 'Aquesta categoria no es pot esborrar. La pots desactivar.',
        event_category_in_use: 'No es pot esborrar una categoria amb esdeveniments. La pots desactivar.',
        event_has_linked_routines: "No es pot canviar la data, l'hora ni la ubicació de l'esdeveniment: té viatges que encara no han sortit.",
        event_has_trips: "No es pot esborrar un esdeveniment amb viatges. Cancel·la'l en el seu lloc.",
        ticketmaster_not_configured: 'La consulta a Ticketmaster no està configurada al servidor.',
        ticketmaster_unavailable: 'Ara mateix no es pot consultar Ticketmaster. Torna-ho a provar d’aquí a uns minuts.',
        football_data_not_configured: 'La consulta a football-data no està configurada al servidor.',
        football_data_unavailable: 'Ara mateix no es pot consultar football-data. Torna-ho a provar d’aquí a uns minuts.',
        football_data_no_category: 'No hi ha cap categoria activa de futbol ni d’esport per als partits.',
      },

      AUTH: {
        AUTH_CREDENTIAL_MISSING: 'Es requereix autenticació per accedir a aquest recurs.',
        AUTH_CREDENTIAL_FORMAT_INVALID: 'La credencial d\'accés no té un format vàlid.',
        AUTH_CREDENTIAL_INTEGRITY_INVALID: 'La credencial d\'accés no és vàlida.',
        AUTH_SESSION_EXPIRED_X0001: 'La teva sessió ha expirat. Inicia sessió de nou.',
        AUTH_SESSION_EXPIRED_X0002: 'La teva sessió ha expirat. Inicia sessió de nou.',
        AUTH_SESSION_EXPIRED_X0003: 'La teva sessió ha expirat. Inicia sessió de nou.',
        AUTH_SESSION_REFERENCE_MISSING: 'No s\'ha pogut identificar la sessió.',
        AUTH_SESSION_NOT_FOUND: 'La sessió ja no està disponible.',
        AUTH_SESSION_REVOKED: 'La sessió ja no està activa. Inicia sessió de nou.',
        AUTH_IDENTITY_NOT_FOUND: 'La identitat associada a la sessió no està disponible.',
        AUTH_APPLICATION_NOT_ALLOWED: 'L\'aplicació d\'accés no està permesa.',
        AUTH_ACCESS_CONTEXT_MISMATCH: 'El context d\'accés no és vàlid per a aquest recurs.',
        AUTH_CREDENTIAL_REJECTED: 'La credencial d\'accés ha estat rebutjada.',
        AUTH_REQUIRED: 'Es requereix autenticació per accedir a aquest recurs.',
        AUTH_PERMISSION_DENIED: 'No tens permisos per accedir a aquest recurs.',
        AUTH_BACKOFFICE_PERMISSION_DENIED: 'No tens permisos per accedir al backoffice.',
        AUTH_CHANNEL_REQUIRED: 'Es requereix autenticació per a aquest canal.',
        AUTH_CHANNEL_PERMISSION_DENIED: 'No tens permisos suficients per a aquest canal.',
        AUTH_TEMPORARILY_UNAVAILABLE: 'El servei d\'autenticació no està disponible temporalment.',
        AUTH_INTERNAL_ERROR: 'No s\'ha pogut completar la validació d\'accés.',
      },

      FIELD: {
        name: 'nom',
        surname: 'cognoms',
        email: 'correu electrònic',
        password: 'contrasenya',
        phone: 'telèfon',
        code: 'codi',
        label: 'etiqueta',
      },

      RULE: {
        accepted: 'Cal acceptar el camp {{field}}.',
        after: 'El camp {{field}} ha de ser una data posterior a {{p0}}.',
        after_or_equal: 'El camp {{field}} ha de ser una data igual o posterior a {{p0}}.',
        alpha: 'El camp {{field}} només pot contenir lletres.',
        alpha_dash: 'El camp {{field}} només pot contenir lletres, números, guions i guions baixos.',
        alpha_num: 'El camp {{field}} només pot contenir lletres i números.',
        array: 'El camp {{field}} ha de ser una llista.',
        before: 'El camp {{field}} ha de ser una data anterior a {{p0}}.',
        before_or_equal: 'El camp {{field}} ha de ser una data igual o anterior a {{p0}}.',
        between: 'El camp {{field}} ha d\'estar entre {{p0}} i {{p1}}.',
        boolean: 'El camp {{field}} ha de ser vertader o fals.',
        confirmed: 'La confirmació del camp {{field}} no coincideix.',
        current_password: 'La contrasenya no és correcta.',
        date: 'El camp {{field}} no és una data vàlida.',
        date_equals: 'El camp {{field}} ha de ser la data {{p0}}.',
        date_format: 'El camp {{field}} no té el format {{p0}}.',
        decimal: 'El camp {{field}} ha de tenir {{values}} decimals.',
        different: 'Els camps {{field}} i {{p0}} han de ser diferents.',
        digits: 'El camp {{field}} ha de tenir {{p0}} dígits.',
        digits_between: 'El camp {{field}} ha de tenir entre {{p0}} i {{p1}} dígits.',
        dimensions: 'La imatge del camp {{field}} no té unes dimensions vàlides.',
        distinct: 'El camp {{field}} té un valor repetit.',
        email: 'El camp {{field}} ha de ser un correu electrònic vàlid.',
        ends_with: 'El camp {{field}} ha d\'acabar en un d\'aquests valors: {{values}}.',
        enum: 'El valor seleccionat a {{field}} no és vàlid.',
        exists: 'El valor seleccionat a {{field}} no és vàlid.',
        file: 'El camp {{field}} ha de ser un fitxer.',
        filled: 'El camp {{field}} ha de tenir un valor.',
        gt: 'El camp {{field}} ha de ser més gran que {{p0}}.',
        gte: 'El camp {{field}} ha de ser més gran o igual que {{p0}}.',
        image: 'El camp {{field}} ha de ser una imatge.',
        in: 'El valor seleccionat a {{field}} no és vàlid.',
        in_array: 'El camp {{field}} no existeix a {{p0}}.',
        integer: 'El camp {{field}} ha de ser un nombre enter.',
        ip: 'El camp {{field}} ha de ser una adreça IP vàlida.',
        json: 'El camp {{field}} ha de ser un JSON vàlid.',
        lowercase: 'El camp {{field}} ha d\'estar en minúscules.',
        lt: 'El camp {{field}} ha de ser més petit que {{p0}}.',
        lte: 'El camp {{field}} ha de ser més petit o igual que {{p0}}.',
        max: 'El camp {{field}} supera el màxim permès ({{p0}}).',
        max_digits: 'El camp {{field}} no pot tenir més de {{p0}} dígits.',
        mimes: 'El camp {{field}} ha de ser un fitxer de tipus: {{values}}.',
        mimetypes: 'El camp {{field}} ha de ser un fitxer de tipus: {{values}}.',
        min: 'El camp {{field}} no arriba al mínim permès ({{p0}}).',
        min_digits: 'El camp {{field}} ha de tenir com a mínim {{p0}} dígits.',
        multiple_of: 'El camp {{field}} ha de ser múltiple de {{p0}}.',
        not_in: 'El valor seleccionat a {{field}} no és vàlid.',
        not_regex: 'El format del camp {{field}} no és vàlid.',
        numeric: 'El camp {{field}} ha de ser un número.',
        password: 'La contrasenya no compleix els requisits de seguretat.',
        present: 'El camp {{field}} ha de ser present.',
        prohibited: 'El camp {{field}} no està permès.',
        prohibited_if: 'El camp {{field}} no està permès en aquest cas.',
        prohibited_unless: 'El camp {{field}} no està permès en aquest cas.',
        prohibits: 'El camp {{field}} no permet omplir {{values}} alhora.',
        regex: 'El format del camp {{field}} no és vàlid.',
        required: 'El camp {{field}} és obligatori.',
        required_array_keys: 'Al camp {{field}} li falten dades obligatòries.',
        required_if: 'El camp {{field}} és obligatori en aquest cas.',
        required_unless: 'El camp {{field}} és obligatori en aquest cas.',
        required_with: 'El camp {{field}} és obligatori quan s\'indica {{values}}.',
        required_with_all: 'El camp {{field}} és obligatori quan s\'indiquen {{values}}.',
        required_without: 'El camp {{field}} és obligatori quan no s\'indica {{values}}.',
        required_without_all: 'El camp {{field}} és obligatori quan no s\'indica cap de: {{values}}.',
        same: 'Els camps {{field}} i {{p0}} han de coincidir.',
        size: 'El camp {{field}} ha de tenir la mida {{p0}}.',
        starts_with: 'El camp {{field}} ha de començar per un d\'aquests valors: {{values}}.',
        string: 'El camp {{field}} ha de ser un text.',
        timezone: 'El camp {{field}} ha de ser una zona horària vàlida.',
        ulid: 'El camp {{field}} ha de ser un identificador vàlid.',
        unique: 'El valor del camp {{field}} ja està en ús.',
        uploaded: 'No s\'ha pogut pujar el fitxer de {{field}}.',
        uppercase: 'El camp {{field}} ha d\'estar en majúscules.',
        url: 'El camp {{field}} ha de ser una URL vàlida.',
        uuid: 'El camp {{field}} ha de ser un identificador vàlid.',

        // Reglas escritas como clase en el backend (app/Rules), en snake_case
        base64_image: 'El camp {{field}} ha de ser una imatge png, jpeg, jpg o webp en base64 de 4 MB com a màxim.',
        referral_phone_country: 'El telèfon ha de ser d\'Espanya (+34) o França (+33) i tenir els dígits correctes.',
        reclamation_subcategory_belongs_to_category: 'La subcategoria no pertany a la categoria indicada.',
        ride_product_description_locales: 'La descripció només admet els idiomes es, en i ca.',
        safe_reclamation_snapshot: 'El camp {{field}} no és vàlid: és massa gran, massa niuat o conté dades sensibles.',
        unique_user_document: 'El document d\'identitat no és vàlid o ja està associat a un altre compte.',
        valid_phone: 'El format del telèfon no és vàlid.',
        valid_user_origin: 'El valor d\'origen no és vàlid o no existeix.',
      },
    },
  },
};
